export default __webpack_public_path__ + "static/service_shape-dc4ff3212250bd0cfdb37e72fe630556.png";